import { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import constate from 'constate';

import { UserContext } from '../contexts/index.jsx';

const [
  MerchantSettingsProvider,
  useTemplate,
  useCallToAction,
  useAccount,
  useSubscription,
  useRequestProduct,
] = constate(
  () => {
    const { user } = useContext(UserContext);
    const [merchant, setMerchant] = useState(null);
    const [ctaTitle, setCtaTitle] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
      const loadMerchant = async () => {
        const { data } = await axios.get(`/api/users/${user.merchant_id}`)

        setMerchant(data.user);
        setCtaTitle(data.user?.cta_title || '');
      }

      loadMerchant();
    }, []);

    const saveCta = async () => {
      setSubmitting(true);

      await axios.put(`/api/users/${merchant.id}`, { cta_title: ctaTitle });

      setSubmitting(false);
    }

    return {
      template: {
        submitting,
      },
      callToAction: {
        title: ctaTitle,
        setTitle: setCtaTitle,
        ctaLink: merchant?.cta_setup_link,
        save: saveCta,
      },
      account: {
        merchant,
      },
      subscription: {

      },
      requestProduct: {

      },
    };
  },
  value => value.template,
  value => value.callToAction,
  value => value.account,
  value => value.subscription,
  value => value.requestProduct,
);

export {
  MerchantSettingsProvider,
  useTemplate,
  useCallToAction,
  useAccount,
  useSubscription,
  useRequestProduct,
};
